module.exports = {"460203198":"吉阳区直辖村级区划"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460203.json
// module id = 2318
// module chunks = 0